import React, { useRef, useEffect } from "react";
import JDIHeaderNew from "@/common-components-src/js/header/index";
import JDIFooterNew from "@/common-components-src/js/footer/index2";
import PAGE_TYPE from "@/common-components-src/const/pageType";
import JDIFloatingToolbar from "@/common-components-src/js/floatingToolbar/index";
import { useLocation } from "react-router-dom";
import { JDIHeaderNewMethods } from "@/common-components-src/types/jdiHeaderNew";
import FloatBottomTips from "@/common-components-src/js/address/floatBottomTips";
import { IWindow } from "@/common-components-src/types/global";

export interface IWithHeaderFooterProps {
  // JDIFooter: typeof JDIFooterNew | null;
  JDIHeader: React.RefObject<JDIHeaderNewMethods>; // 改为传递headerRef
}

const withHeaderFooter = <T extends object>(
  WrappedComponent: React.ComponentType<T & IWithHeaderFooterProps>,
): React.FC<Omit<T, keyof IWithHeaderFooterProps>> => {
  const WithHeaderFooter: React.FC<Omit<T, keyof IWithHeaderFooterProps>> = (props) => {
    const headerRef = useRef<JDIHeaderNewMethods | null>(null);
    const footerRef = useRef<HTMLDivElement | null>(null);

    // const [footer, setFooter] = useState<typeof JDIFooterNew | null>(null);

    const location = useLocation();

    const getPageType = (pathname: string): PAGE_TYPE => {
      console.log(pathname, "yz pathname");
      const strArr = pathname
        .toUpperCase()
        .split("/")
        .filter((s) => s !== "");
      const type = strArr[0];
      console.log(type, "yz type");
      switch (type) {
        case "CHECKOUT":
          return PAGE_TYPE.ONLY_LOGO;
        case "LOGIN":
          return PAGE_TYPE.ONLY_LOGO;
        case "FORGOTPASSWORD":
          return PAGE_TYPE.ONLY_LOGO;
        case "FORGOTPASSWORDSUCCESS":
          return PAGE_TYPE.ONLY_LOGO;
        default:
          return PAGE_TYPE.HIDE_CATEGORY;
      }
    };

    const pageType = getPageType(location.pathname);

    useEffect(() => {
      (window as unknown as IWindow).JDIheader = headerRef.current;
    }, []);

    return (
      <>
        <JDIHeaderNew ref={headerRef} pageType={pageType} />
        <WrappedComponent {...(props as T)} JDIHeader={headerRef} />
        <JDIFooterNew />
        <JDIFloatingToolbar />
        {pageType === PAGE_TYPE.HOME && <FloatBottomTips />}
      </>
    );
  };

  WithHeaderFooter.displayName = `WithHeaderFooter(${WrappedComponent.displayName || WrappedComponent.name || "Component"})`;
  return WithHeaderFooter;
};

export default withHeaderFooter;
